export interface ReleaseNote {
  version: string
  date: string
  changes: string[]
}

export const releaseNotes: ReleaseNote[] = [
  {
    version: '1.8.0',
    date: 'July 2026',
    changes: [
      'AskREINZ — added a Clear chat button to start a fresh conversation',
      'Estimate — added a clear button to the address field so you can quickly search a different property',
      'Estimate — reopening a saved property now shows its current valuation instead of the price from when it was saved',
    ],
  },
  {
    version: '1.7.0',
    date: 'June 2026',
    changes: [
      'New: Multi-Suburb tab in Market Insights — compare price trends, days to sell, and monthly sales across up to 8 suburbs side by side, with an interactive chart and per-suburb stats breakdown',
      'New: Home screen stats — use the All / Custom toggle to switch between NZ-wide regional data or your personalised view, starting with your default suburb and cycling through your Multi-Suburb selection',
      'Daily Survey — tap the survey card header to minimise or expand it at any time',
    ],
  },
  {
    version: '1.6.0',
    date: 'May 2026',
    changes: ['REINZ Companion launched — built exclusively for REINZ members.'],
  },
]
